import { autoHydrate } from "../utils/auto_hydrate";
import { SlidesSection } from "./new/sections/slides";
import { NearYouSection } from "./new/sections/near-you";
import { OverlaySlideDown } from "./new/overlay-slider";
import { NavigationBar } from "./navigation-bar";

export const COMPONENT_MAP = {
  NavigationBar,
  SlidesSection,
  NearYouSection,
};

const AH = {};
for (let i in COMPONENT_MAP) {
  AH[i] = autoHydrate(COMPONENT_MAP[i], i);
}

export { AH };
